/* eslint-disable no-console */
import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import Scroll, { scrollSpy } from 'react-scroll';
import classNames from 'classnames';
import Autosuggest from 'react-autosuggest';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import { Responsive } from 'common/components';
import searchIcon from 'assets/client/imgs/icon-search.svg';
// import { artistName } from './artist-name';

import * as css from './Search.scss';

const letters = _.shuffle('abcdefghijklmnopqrstuvwxyz'.split(''));

function escapeRegexCharacters(str) {
	return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

class Search extends Component {
	static get alphabet() {
		const result = letters;

		return result;
	}

	state = {
		value: '',
		suggestions: [],
	};

	listForAutocomplete = [
		{
			languages: [], // authors
		},
		{
			languages: [], // songs
		},
	];

	constructor(props) {
		super(props);
		this.searchRef = React.createRef();
	}

	componentDidMount() {
		const athorWithoutDublicates = [];

		_.forEach(this.props.allSongs, group => {
			return _.map(group, item => {
				athorWithoutDublicates.push({
					text: `${item.subtitle.toUpperCase()}`,
					song: `${item.title.toUpperCase()}`,
				});

				this.listForAutocomplete[1].languages.push({
					text: `${item.title.toUpperCase()}`,
					author: `${item.subtitle.toUpperCase()}`,
				});
			});
		});

		// remove dublicates for authors array
		this.listForAutocomplete[0].languages = _.reduce(
			athorWithoutDublicates,
			(acc, item, index) => {
				const duplicateIndex = _.findIndex(acc, a => a.text === item.text);

				if (duplicateIndex < 0) {
					acc.push({ text: item.text, song: item.song });
				}

				return acc;
			},
			[]
		);
	}

	getSuggestions = value => {
		const escapedValue = escapeRegexCharacters(value.trim());

		if (escapedValue === '') {
			return [];
		}

		const regex = new RegExp(`^${escapedValue}`, 'i');

		const list = this.listForAutocomplete
			.map(section => {
				return {
					languages: section.languages.filter(language => regex.test(language.text)),
				};
			})
			.filter(section => section.languages.length > 0);

		return list;
	};

	onChange = (event, { newValue }) => {
		this.setState({
			value: newValue,
		});
	};

	// onFocus = () => {
	// 	analytics.onSearch();
	// };

	onSuggestionsFetchRequested = ({ value }) => {
		this.setState({
			suggestions: this.getSuggestions(value),
		});
	};

	onSuggestionsClearRequested = () => {
		this.setState({
			suggestions: [],
		});
	};

	getSuggestionValue = suggestion => {
		return suggestion.text;
	};

	onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
		const { /* isScrolling, */ setIsAuthorSelected, searchResult } = this.props;
		let htmlName;

		if (_.has(suggestion, 'song')) {
			const item = _.find(this.listForAutocomplete[0].languages, { text: suggestionValue.toUpperCase() });
			htmlName = `${item.text} - ${item.song}`;

			setIsAuthorSelected(true);
		} else {
			const item = _.find(this.listForAutocomplete[1].languages, { text: suggestionValue.toUpperCase() });
			htmlName = `${item.author} - ${item.text}`;

			setIsAuthorSelected(false);
		}

		searchResult(htmlName);

		// console.info(Scroll.scroller, htmlName);
		// Scroll.scroller.scrollTo(`${htmlName}`, {
		// 	offset: isMobile() ? -40 : -220,
		// });

		setTimeout(() => {
			const element = document.querySelectorAll(`[data-name="${htmlName}"]`)[0];

			if (Responsive.isMatching(Responsive.MOBILE)) {
				const topOffset = element.getBoundingClientRect().top;
				const serchOffset = this.searchRef.current.getBoundingClientRect().top;

				window.scrollTo({
					top: topOffset - serchOffset + 70,
					behavior: 'smooth',
				});
			} else {
				element.scrollIntoView();
			}
		}, 100);
	};

	clearInput = () => {
		this.setState({ value: '' });
		this.props.searchResult('');
	};

	renderSectionTitle = section => {
		return <strong>{section.title}</strong>;
	};

	getSectionSuggestions = section => {
		return section.languages;
	};

	renderSuggestion = (suggestion, { query }) => {
		const matches = AutosuggestHighlightMatch(suggestion.text, query);
		const parts = AutosuggestHighlightParse(suggestion.text, matches);

		return (
			<span>
				<span className="name">
					{_.map(parts, (part, index) => {
						const className = part.highlight ? css.highlight : null;

						return (
							<span className={className} key={index}>
								{part.text}
							</span>
						);
					})}
				</span>
			</span>
		);
	};

	render() {
		const { value, suggestions } = this.state;
		const { isScrolling } = this.props;
		const inputProps = {
			value,
			onChange: this.onChange,
			// onFocus: this.onFocus,
		};
		const isSearchIconHidden = value && value.length > 0;

		return (
			<div className={classNames(css.search, { [css.isScrolling]: isScrolling })}>
				<div className={css.inner} ref={this.searchRef}>
					<Autosuggest
						multiSection
						suggestions={suggestions}
						onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
						onSuggestionsClearRequested={this.onSuggestionsClearRequested}
						getSuggestionValue={this.getSuggestionValue}
						renderSuggestion={this.renderSuggestion}
						renderSectionTitle={this.renderSectionTitle}
						getSectionSuggestions={this.getSectionSuggestions}
						onSuggestionSelected={this.onSuggestionSelected}
						inputProps={inputProps}
						highlightFirstSuggestion
					/>
					<img
						src={searchIcon}
						alt=""
						className={classNames(css.searchIcon, isSearchIconHidden && css.searchIconIsHidden)}
					/>
					<div
						className={classNames(css.clearIcon, isSearchIconHidden && css.clearIconIsVisible)}
						onClick={this.clearInput}
					/>
				</div>
			</div>
		);
	}
}

Search.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	allSongs: PropTypes.arrayOf(PropTypes.array).isRequired,
	searchResult: PropTypes.func.isRequired,
	isScrolling: PropTypes.bool.isRequired,
	setIsAuthorSelected: PropTypes.func.isRequired,
};

export default Search;
